import { connect } from 'react-redux';
import AgreementServiceDetailFormComponent from '../AgreementServiceDetailForm/AgreementServiceDetailFormComponent';
import { useBoolean } from '@fluentui/react-hooks';
import { AgreementServicesDetail } from '../../../models/Entities/AgreementServices/AgreementServicesDetail';
import { IconButton, Toggle, TooltipHost } from '@fluentui/react';
import { useTranslation } from 'react-i18next';

// Functions
import * as ComponentFunctions from './AgreementServiceDetailsItemComponentFunctions';

export const AgreementServiceDetailItemComponent = (
  props: ComponentFunctions.Props
) => {
  const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);

  const [t] = useTranslation();

  const ChangeStatusHandler = (details: AgreementServicesDetail) => {
    details.isActive = !details.isActive;
    props.UpdateAgreementServiceDetail(details);
  };

  const hasDetail = !!props.AgreementServiceDetail;
  const isActive = props.AgreementServiceDetail?.isActive ?? false;

  const planName = props.Plan?.title ?? '';
  const serviceName = props.Service?.medicalService?.serviceNameReference ?? '';
  const coverageLabel = `${serviceName} · ${planName}`;

  const toggleTooltip = hasDetail
    ? t(
        isActive
          ? 'agreementServiceDetailItem.tooltip.deactivate'
          : 'agreementServiceDetailItem.tooltip.activate',
        { coverage: coverageLabel }
      )
    : t('agreementServiceDetailItem.tooltip.configure', { coverage: coverageLabel });

  const propertiesTooltip = t('agreementServiceDetailItem.tooltip.properties', {
    coverage: coverageLabel
  });

  return (
    <>
      {/* Both branches share the same wrapper and the same two slots, so the
          toggles line up column to column whether or not the plan already has
          a detail with its properties button. */}
      <div className="serviceDetailsOptions">
        <TooltipHost content={toggleTooltip}>
          <Toggle
            checked={isActive}
            ariaLabel={toggleTooltip}
            onClick={() =>
              hasDetail
                ? ChangeStatusHandler(props.AgreementServiceDetail)
                : openPanel()
            }
          />
        </TooltipHost>

        {hasDetail ? (
          <IconButton
            iconProps={ComponentFunctions.SettingsIcon}
            title={propertiesTooltip}
            ariaLabel={propertiesTooltip}
            onClick={() => openPanel()}
          />
        ) : (
          <span className="serviceDetailsOptions__spacer" aria-hidden="true" />
        )}
      </div>

      {isOpen && (
        <AgreementServiceDetailFormComponent
          dismissPanel={dismissPanel}
          openPanel={() => undefined}
          insurancePlanId={props.Plan?.id}
          insurancePlanReferenceName={props.Plan?.title}
          AgreementService={props.Service}
          isOpen={isOpen}
          SelectedDetails={props.AgreementServiceDetail}
        />
      )}
    </>
  );
};

export default connect(
  ComponentFunctions.mapStateToProps,
  ComponentFunctions.mapDispatchToProps
)(AgreementServiceDetailItemComponent as any);
